import Select, { SelectProps } from "@/shared/form/select";
import { useTranslations } from "use-intl";

export function RouteStepTypeSelect(props: SelectProps) {
  const t = useTranslations("RoleOrPersonSelect");

  return (
    <Select
      options={[
        {
          label: t("Role"),
          value: "role",
          "data-testid": "route-step-type-option-role",
        },
        {
          label: t("Person"),
          value: "person",
          "data-testid": "route-step-type-option-person",
        },
      ]}
      {...props}
    />
  );
}
